import _ from 'underscore';

import { MenuItemCategory } from '@biteinc/enums';

app.StarbucksAdditionalRetailItemsView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} virtual-sub-group-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {
          sku: '',
          name: '',
          category: MenuItemCategory.NonalcoholicBeverage,
          menuSectionI9nId: '',
        };
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();
        return fields?.name;
      },
      templateData: {
        title: 'Additional Retail Items',
        buttonText: 'New retail item',
        emptyText: 'No retail items yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
